import axios from "axios";
import { LoginApi } from "../../domain/interfaces/loginApi";

export class AuthImplementation implements LoginApi {
  async login(
    tipoDocumento: string,
    user: string,
    password: string,
    recordarme: boolean
  ): Promise<string> {
   // const username: string = tipoDocumento + user;

    try {
      const response = await axios.post<Response>(
        process.env.REACT_APP_API_URL + "/auth/login",
        {
          password: password,
          tipo: tipoDocumento,
          numero: user,
        }
      );

      return response.data.access_token;
    } catch (error) {
      console.error("Error al hacer login:", error);
      
      // Extraer mensaje de error de la respuesta 401
      if (axios.isAxiosError(error) && error.response) {
        const errorMessage = error.response.data?.message || error.response.data?.error || "Error de autenticación";
        throw new Error(errorMessage);
      }
      
      throw new Error("Error de conexión");
    }
  }
}

interface Response {
  access_token: string;
}
